import React from 'react';
import { Send } from 'lucide-react';
import type { BulkEmailMenuState } from '../../../types/table';
import { TABLE_Z_INDEX } from '../../../constants/table';

export interface BulkEmailContextMenuProps {
  menuState: BulkEmailMenuState;
  onSendCampaign: () => void;
}

/**
 * Context menu for bulk email actions when multiple rows are selected
 */
export const BulkEmailContextMenu: React.FC<BulkEmailContextMenuProps> = ({
  menuState,
  onSendCampaign,
}) => {
  if (!menuState.show) return null;

  const rowCount = menuState.selectedRows.size;

  return (
    <div
      className="fixed bg-white border border-gray-200 rounded-lg shadow-lg py-2 min-w-48"
      style={{
        left: `${menuState.x}px`,
        top: `${menuState.y}px`,
        zIndex: TABLE_Z_INDEX.CONTEXT_MENU,
      }}
    >
      <div className="px-4 py-2 text-sm text-gray-600 border-b border-gray-100">
        {rowCount} {rowCount === 1 ? 'row' : 'rows'} selected
      </div>
      <button
        id="bulk-email-send-btn"
        onClick={onSendCampaign}
        className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
      >
        <Send className="w-4 h-4 mr-2" />
        Send Email Campaign
      </button>
    </div>
  );
};

BulkEmailContextMenu.displayName = 'BulkEmailContextMenu';
